import React from 'react'
import { useState, useEffect } from 'react';
import RequestService from '../../services/RequestService';


export default function MinorCollectOrderDetails({ collectOrder, request }) {

  const [requestObject, setRequestObject] = useState(collectOrder?.idRequest);

  useEffect(() => {
    async function fetchRequest() {
      if (!request && collectOrder?.idRequest) {
        try {
          const request = await RequestService.getRequestById(collectOrder.idRequest);
          setRequestObject(request); // Descomente esta linha para salvar o request no estado, se necessário
        } catch (error) {
          console.error("Erro ao buscar a solicitação:", error);
        }
      }
    }
  
    fetchRequest();
  }, [collectOrder?.idRequest, request]);



  return (

    <div className="flex flex-col gap-2 mt-2 mx-2 text-[11px]">
      {/* DIV Usuario */}
      <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="absolute right-4 top-2 text-blue-400 font-bold">
          <a href="#">Ver mais</a>
        </div>

        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1 w-1/2">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Nome Solicitante:
            </label>
            <div>{collectOrder?.user?.name}</div>
          </div>
          <div className="flex items-start gap-1  w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              RE/Legal Solicitante:
            </label>
            <div>
              {collectOrder?.user?.reLegal}
            </div>
          </div>
        </div>
        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1  w-1/2">
            <label className="block text-gray-700 font-bold">
              UF:
            </label>
            <div>{collectOrder?.user?.uf}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Empresa:
            </label>
            <div>{collectOrder?.empresaTecnico?.socialName}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Contato:
            </label>
            <div>{collectOrder?.user?.phone}</div>
          </div>
        </div>
      </div>

      {/* DIV Equipamento */}
      <div className="flex py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="flex flex-col gap-3 w-full whitespace-nowrap">
          <div className="flex gap-6">
            <div className="flex items-start gap-1">
              <label className="block text-gray-700 font-bold whitespace-nowrap">
                Cod. Sap:
              </label>
              <div>{collectOrder?.codEquipamentoColeta}</div>
            </div>

            <div className="flex items-start gap-1">
              <label className="block text-gray-700 font-bold">
                Equipamento:
              </label>
              <div className="w-fit whitespace-break-spaces">{collectOrder?.nomeEquipamentoColeta}</div>
            </div>
          </div>

          <div className="flex gap-6">
            <div className="flex items-start gap-1">
              <label className="block text-gray-700 font-bold">
                Fabricante:
              </label>
              <div>{collectOrder?.fabricanteEquipamentoColeta}</div>
            </div>
            <div className="flex items-start justify-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Quantidade Coleta:
            </label>
            <div>{collectOrder?.qtdColeta}</div>
          </div>
          </div>
        </div>
      </div>

      {/* DIV Endereço Coleta */}
      <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="flex flex-row gap-8 w-full whitespace-nowrap">
          <div className="flex items-start gap-1">
            <label className="block text-gray-700 font-bold">
              GMO:
            </label>
            <div>
              {collectOrder?.gmo.cidade}
              {collectOrder?.gmo.identificador ? (' - ' + collectOrder.gmo.identificador) : ''}
            </div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold">
              Endereço Gmo:
            </label>
            <div>{collectOrder?.gmo.endereco}</div>
          </div>
        </div>

        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold">
              Endereço Coleta:
            </label>
            <div>{collectOrder?.enderecoColeta}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold">
              Complemento:
            </label>
            <div>{collectOrder?.enderecoColetaComplemento}</div>
          </div>
        </div>
      </div>

      {/* DIV Deposito Coletor */}
      {/* {collectOrder?.deposit && */}
      <div>
        <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
          <div className="flex flex-row gap-8 w-full whitespace-nowrap">
            <div className="flex items-start gap-1 w-full">
              <label className="block text-gray-700 font-bold">
                Deposito Coletor:
              </label>
              { collectOrder?.deposit ?
              <div>{collectOrder?.deposit.sigla} - {collectOrder?.deposit.cidade} - {collectOrder?.deposit.endereco}</div> :
              (request || requestObject?.request)?.drsAtender ? 
              <div>{(request || requestObject?.request)?.drsAtender.sigla} - {(request || requestObject?.request)?.drsAtender.cidade} - {(request || requestObject?.request)?.drsAtender.endereco}</div> :
              (request || requestObject?.request)?.drsOriginal ?
              <div>{(request || requestObject?.request)?.drsOriginal.sigla} - {(request || requestObject?.request)?.drsOriginal.cidade} - {(request || requestObject?.request)?.drsOriginal.endereco}</div> :
              ""
              }
              {/* { request !== undefined ? <div onClick={()=>{console.log(request)}}>TEM REQUEST</div> : <div>NÃO TEM</div>} */}
            </div>
          </div>
        </div>
      </div>
      {/* } */}

      {/* CÓDIGOS DE BARRAS */}
      {collectOrder?.codItemsColetados.length > 0 &&
        <div className="flex flex-col px-4 py-2 bg-gray-50 border rounded-md relative">
          <div className="font-bold text-gray-700">Itens:</div>
          <div className="flex flex-col gap-1 mt-2">
            <div
              className="w-full h-[100px] overflow-y-auto bg-white border border-zinc-300 rounded-md"
            >
              {collectOrder?.codItemsColetados && collectOrder?.codItemsColetados.length > 0 ? (
                <table className="min-w-full text-xs text-left text-gray-500">
                  <thead className="bg-gray-200 text-gray-700">
                    <tr>
                      <th className="px-1 py-1">#</th>
                      <th className="px-1 py-1">Código de Barras</th>
                      <th className="px-1 py-1">Serial</th>
                    </tr>
                  </thead>
                  <tbody>
                    {collectOrder.codItemsColetados.map((item, index) => (
                      <tr key={index} className="border-b text-xs">
                        <td className="px-1 py-1">{index + 1}</td>
                        <td className="px-1 py-1">{item.codigo}</td>
                        <td className="px-1 py-1">{item.serialNumber}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="text-xs text-gray-500">Nenhum código de barras disponível.</div>
              )}
            </div>
          </div>
        </div>
      }

      {/* ITENS INFORMADOS */}
      {collectOrder?.codItensInformados && collectOrder?.codItensInformados.length > 0 &&
        <div className="flex flex-col px-4 py-2 bg-gray-50 border rounded-md relative mt-2">
          <div className="font-bold text-gray-700">Itens Informados:</div>
          <div className="flex flex-col gap-1 mt-2">
            <div className="w-full h-[100px] overflow-y-auto bg-white border border-zinc-300 rounded-md">
              <table className="min-w-full text-xs text-left text-gray-500">
                <thead className="bg-gray-200 text-gray-700">
                  <tr>
                    <th className="px-1 py-1">#</th>
                    <th className="px-1 py-1">Serial</th>
                    <th className="px-1 py-1">Código de Defeito</th>
                    <th className="px-1 py-1">Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {collectOrder.codItensInformados.map((item, index) => (
                    <tr key={index} className="border-b text-xs">
                      <td className="px-1 py-1">{index + 1}</td>
                      <td className="px-1 py-1">{item.serialNumber}</td>
                      <td className="px-1 py-1">{item.idDefeitoSGS}</td>
                      <td className="px-1 py-1">{item.nomeDefeitoSGS}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

    </div>

  )
}
